import { useFormContext } from 'react-hook-form'

import {
  FormDescription,
  FormError,
  FormField,
  FormItem,
  FormLabel,
  SearchSelect,
} from '@fortem-monorepo/react-ui'
import { ContentBlocks } from '@fortem-monorepo/web-sdk'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

export interface ValueColumnFieldProps {
  valueColumns?: ContentBlocks.DataGridColumn[]
}

export const ValueColumnField: React.FC<ValueColumnFieldProps> = ({ valueColumns = [] }) => {
  const { control, setValue } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="value_column"
      control={control}
      render={({ field: { value } }) => (
        <FormItem>
          <div className="flex items-center gap-2 overflow-hidden">
            <FormLabel>Value Column</FormLabel>
            <FormError />
          </div>
          <FormDescription>
            Select the single value this guideline evaluates against its thresholds.
          </FormDescription>
          <SearchSelect
            value={value}
            placeholder="Select a value column..."
            setValue={(val) =>
              setValue('value_column', val, {
                shouldValidate: true,
                shouldDirty: true,
              })
            }
            options={valueColumns.map((col) => ({
              label: col.label,
              value: col.name,
            }))}
          />
        </FormItem>
      )}
    />
  )
}
